<div mat-dialog-title>
  {{ 'Send us feedback' | translate }}
</div>

<div mat-dialog-content>
  <mat-form-field>
    <textarea matInput [placeholder]="'Type your feedback here' | translate" #feedback autofocus></textarea>
  </mat-form-field>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="sendFeedback(feedback.value)" mat-dialog-close [disabled]="!feedback.value">
    {{ 'Send feedback' | translate }}
  </button>
</div>
